export default (app, inject) => {
  const i18n = app.i18n
  const getRoomName = (room, count = 1) => {
    const key = `rooms.${room.split('-')[0]}`
    return i18n.tc(key, count)
  }
  inject('getRoomName', getRoomName)
}
